import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { brand } from '../mock';

export default function RegistrationSuccess({ success, onRegisterAnother }) {
  const firstName = (success.name || '').split(' ')[0] || 'Parent';
  return (
    <section id="register" className="py-16 lg:py-24">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="bg-white border-2 border-[#2C3E50] rounded-3xl p-8 lg:p-12 text-center paper-shadow">
          <div className="w-20 h-20 mx-auto rounded-full bg-[#4FB3B8] border-2 border-[#2C3E50] flex items-center justify-center paper-shadow-sm">
            <CheckCircle2 size={40} className="text-white" strokeWidth={2.5} />
          </div>
          <h2 className="mt-6 text-3xl lg:text-4xl font-black text-[#2C3E50]" style={{ fontFamily: 'Fraunces, serif' }}>
            You&rsquo;re registered, {firstName}!
          </h2>
          <p className="mt-3 text-[#2C3E50]/75 text-lg">
            Your FREE demo class request has been received. Our counsellor will call you within 30 minutes to schedule the demo.
          </p>
          {success.registrationId && (
            <div className="mt-6 inline-block bg-[#FFF8EC] border-2 border-[#2C3E50] rounded-xl px-4 py-2">
              <div className="text-[10px] uppercase tracking-widest font-black text-[#2C3E50]/60">Reference ID</div>
              <div className="font-mono text-sm font-black text-[#2C3E50] break-all">{success.registrationId}</div>
            </div>
          )}
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <a href={`tel:${brand.phoneRaw}`} className="px-5 py-3 rounded-md bg-[#2C3E50] text-white font-black border-2 border-[#2C3E50] hover:bg-[#E64B2B] hover:border-[#E64B2B]">Call us now</a>
            <button type="button" onClick={onRegisterAnother} className="px-5 py-3 rounded-md bg-white text-[#2C3E50] font-black border-2 border-[#2C3E50] hover:bg-[#F4B93E]">Register another child</button>
          </div>
        </div>
      </div>
    </section>
  );
}
